import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * HostRoute - Protected route for hosts and admins only
 * Regular users (guests) will be redirected to host application page
 */
const HostRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#D65A31]" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Only hosts and admins can access these routes
  if (user?.role !== 'host' && user?.role !== 'admin') {
    return <Navigate to="/host" replace />;
  }

  return children;
};

export default HostRoute;
